import { render } from "./CamsView.vue?vue&type=template&id=99d1bb80&scoped=true"
import script from "./CamsView.vue?vue&type=script&lang=js"
export * from "./CamsView.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-99d1bb80"

export default script